export const UNLIMITED_TENANT_IDS = ['b97a45ec-2061-702b-4660-dca5c467520f']
// "f9ba95ac-50c1-701c-e675-f7b96d07f36a"
export const FORCE_EMAILS_TO_VIETNAM = ['localbookablevn@gmail.com']
